exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " ::-webkit-inner-spin-button { \r\n  display:none;\r\n}\r\n/* ::-webkit-calendar-picker-indicator { background-color:rgb(58, 53, 53)} */\r\ninput[type=\"date\"]{\r\n  font-size:13px !important;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n/*::-webkit-datetime-edit-text { color:#555555}\r\n::-webkit-datetime-edit-month-field { color:#555555 }\r\n::-webkit-datetime-edit-day-field { color: #555555; }\r\n::-webkit-datetime-edit-year-field { color:#555555; }*/\r\n/* ::-webkit-calendar-picker-indicator{  */\r\n  /* background-image: url('/src/assets/images/calendar.png'); */\r\n      /* background-position:center; */\r\n       /* background-size:25px 25px; */\r\n       /* background-repeat:no-repeat; */\r\n      /* color:rgba(204,204,204,0); */\r\n/* } */\r\ninput[type=\"date\"]::-webkit-clear-button {\r\n    font-size: 18px;\r\n    height: 30px;\r\n    position: relative;\r\n    display: none;\r\n    \r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/date/date.css
// module id = 1095
// module chunks = 322